/**
 * 2019-04-12
 * handan
 * 统一对外暴漏render，做一个render合并
 */

import { combineReducers } from "redux";
import verifyResult from "./verifyResult";
import modalPop from "./modalPop";
import loading from "./loading";
import home from "./home";

export default combineReducers({
  verifyResult,
  modalPop,
  loading,
  home,
})